import type { IconComponentBaseProps } from 'components/atoms/Icon/types';

import { defaultTheme } from '@/theme';

type ArrowAndEdgeProps = IconComponentBaseProps;

export const ArrowAndEdge = ({
  className,
  width = 24,
  height = 24,
  fill = defaultTheme.mantineColors.gray[7],
}: ArrowAndEdgeProps) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_7638_865"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <rect width="24" height="24" fill={fill} />
      </mask>
      <g mask="url(#mask0_7638_865)">
        <path
          d="M11.25 17.6463V13.0385C11.25 12.4565 11.0429 11.9584 10.6287 11.5443C10.2147 11.1301 9.71674 10.923 9.13474 10.923H3.42299C2.92433 10.923 2.49841 10.7464 2.14524 10.3932C1.79208 10.0401 1.61549 9.61417 1.61549 9.1155V4.25C1.61549 4.03717 1.68724 3.859 1.83074 3.7155C1.97441 3.57183 2.15266 3.5 2.36549 3.5C2.57833 3.5 2.75649 3.57183 2.89999 3.7155C3.04366 3.859 3.11549 4.03717 3.11549 4.25V9.1155C3.11549 9.20517 3.14433 9.27883 3.20199 9.3365C3.25966 9.39417 3.33333 9.423 3.42299 9.423H9.13474C9.72824 9.423 10.2737 9.5535 10.7712 9.8145C11.2686 10.0753 11.6782 10.4269 12 10.8693C12.3218 10.4269 12.7314 10.0753 13.2287 9.8145C13.7262 9.5535 14.2717 9.423 14.8652 9.423H20.577C20.6667 9.423 20.7403 9.39417 20.798 9.3365C20.8557 9.27883 20.8845 9.20517 20.8845 9.1155V4.25C20.8845 4.03717 20.9563 3.859 21.1 3.7155C21.2435 3.57183 21.4217 3.5 21.6345 3.5C21.8473 3.5 22.0256 3.57183 22.1692 3.7155C22.3127 3.859 22.3845 4.03717 22.3845 4.25V9.1155C22.3845 9.61417 22.2079 10.0401 21.8547 10.3932C21.5016 10.7464 21.0757 10.923 20.577 10.923H14.8652C14.2832 10.923 13.7852 11.1301 13.3712 11.5443C12.9571 11.9584 12.75 12.4565 12.75 13.0385V17.6365L14.0577 16.3385C14.1962 16.2 14.3693 16.1292 14.577 16.126C14.7847 16.1228 14.9628 16.1937 15.1115 16.3385C15.2602 16.4872 15.3329 16.6653 15.3297 16.873C15.3266 17.0807 15.2507 17.2589 15.102 17.4078L12.6327 19.877C12.4519 20.0577 12.241 20.148 12 20.148C11.759 20.148 11.5481 20.0577 11.3672 19.877L8.87299 17.3828C8.73466 17.2443 8.66291 17.0728 8.65774 16.8683C8.65258 16.6638 8.72433 16.4872 8.87299 16.3385C9.01149 16.1937 9.18716 16.1228 9.39999 16.126C9.61283 16.1292 9.78849 16.2 9.92699 16.3385L11.25 17.6463Z"
          fill={fill}
        />
      </g>
    </svg>
  );
};
